import { Box, InputLabel, TextField, Typography } from "@mui/material";
import MainModal from "components/MainModal";
import { useRCAMainStyles } from "pages/Corporate/RCA/RCA.styles";
import React, { useEffect, useState } from "react";
import { IEditItemModal } from "../RCAFishboneDiagramInterfaces";
import { IFishboneDiagramProblemCause } from "entities/RCA/RCALibraryEntity/RCALibraryEntityInterfaces";
import { useTranslation } from "react-i18next";

const EditItemModal = ({ open, onClose, itemToEdit, onEditItem, disabled }: IEditItemModal) => {
    const mainClasses = useRCAMainStyles();
    const { t } = useTranslation();
    const [itemToEditData, setItemToEditData] = useState<IFishboneDiagramProblemCause | null | undefined>(itemToEdit);

    useEffect(() => {
        setItemToEditData(itemToEdit!);
    }, [itemToEdit]);

    const handleOnClose = () => {
        setItemToEditData(null);
        onClose();
    };

    return (
        <MainModal
            isOpen={open}
            onClose={handleOnClose}
            title={t("rca.rca_library.rca_detail.fishbone_diagram.edit_item")}
            showCloseButton
            customModalStyles={{ width: 600 }}
            onOkButtonClick={() => {
                onEditItem(itemToEditData!);
                handleOnClose();
            }}
            okButton={t("rca.rca_library.rca_detail.fishbone_diagram.save")}
            disableOkButton={!itemToEditData?.description?.trim() || disabled}
        >
            <Box className={`${mainClasses.contentFormBox} ${mainClasses.contentCardContent}`}>
                <InputLabel id="outlined-actionPlanDescription-label">
                    <Typography variant="subtitle2" className={mainClasses.contentFormLabelMaxWidth}>
                        {t("rca.rca_library.rca_detail.fishbone_diagram.edit_item_title")}
                    </Typography>
                </InputLabel>
                <TextField
                    fullWidth
                    className={mainClasses.contentFormMultitextField}
                    multiline
                    rows={3}
                    type="text"
                    placeholder={t("rca.rca_library.rca_detail.fishbone_diagram.edit_placeholder")}
                    variant="outlined"
                    value={itemToEditData?.description || ""}
                    onChange={(e) => setItemToEditData({ ...itemToEditData!, description: e.target.value })}
                />
            </Box>
        </MainModal>
    );
};

export default EditItemModal;
